export default "https://assets.pclncdn.com/web/next-landing/d6942e80/_next/static/images/devices-2630feff4c237888ca229fc9a6b4eb4e.webp";